import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import {
  FormErrorsModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  SpinnerModule,
} from '@spartacus/storefront';
import { CheckoutShipToRddComponent } from './checkout-ship-to-rdd.component';

@NgModule({
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
  ],
  declarations: [CheckoutShipToRddComponent],
  exports: [CheckoutShipToRddComponent],
})
export class CheckoutShipToRddModule {}
